import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useMemo } from 'react';
import FJActionTextToImage from '../../../../redux/action/FJActionTextToImage';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJTextToImageImageUploader from '../view/FJTextToImageImageUploader';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon';
import { removeUploadImages } from '../../../../redux/slices/FJSliceTextToImage';
import FJTextToImageDataConfig from '../../../../config/dataConfig/FJTextToImageDataConfig';

const FJTextToImageImageUploaderContainer = memo(function FJTextToImageImageUploaderContainer() {
    useLocalStore();
    const dispatch = useDispatch();
    const uploadImageInfo = useSelector(state => state.textToImage.uploadImageInfo);
    const uploadImages = useSelector(state => state.textToImage.uploadImages);
    const uploadStatus = useSelector(state => state.textToImage.uploadStatus);
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const curModel = useSelector(state => state.textToImage.curModel);
    const supportImageReferenceNum = useMemo(() => {
        return FJTextToImageDataConfig.MODELS.find(item => item.value === curModel)?.supportImageReferenceNum || 1;
    }, [curModel]);
    const setIsDraggingFile = useCallback(
        isDraggingFile => {
            dispatch(setSliceIsDraggingFileAction(isDraggingFile));
        },
        [dispatch],
    );

    const handleImageUpload = useCallback(
        file => {
            dispatch(FJActionTextToImage.uploadImageAction(file));
        },
        [dispatch],
    );

    const openMediaLibrary = useCallback(() => {
        dispatch(FJActionEditPage.openMediaLibraryAction());
    }, [dispatch]);

    const handleDeleteImage = useCallback(() => {
        dispatch(FJActionTextToImage.clearUploadImageAction());
    }, [dispatch]);
    const handleUploadMultiple = useCallback(
        files => {
            dispatch(FJActionTextToImage.uploadMultipleImagesAction(files));
        },
        [dispatch],
    );

    const handleRemoveImage = useCallback(
        index => {
            dispatch(removeUploadImages(index));
        },
        [dispatch],
    );
    const handleOpenMediaLibrary = useCallback(() => {
        dispatch(FJActionEditPage.openMediaLibraryAction({ canMultipleChoose: true }));
    }, [dispatch]);

    return (
        <FJTextToImageImageUploader
            onUpload={handleImageUpload}
            onOpenMediaLibrary={openMediaLibrary}
            uploadImageInfo={uploadImageInfo}
            uploadStatus={uploadStatus}
            setIsDraggingFile={setIsDraggingFile}
            isDraggingFile={isDraggingFile}
            onDelete={handleDeleteImage}
            uploadImages={uploadImages}
            handleUploadMultiple={handleUploadMultiple}
            handleRemoveImage={handleRemoveImage}
            handleOpenMediaLibrary={handleOpenMediaLibrary}
            supportImageReferenceNum={supportImageReferenceNum}
        />
    );
});

export default FJTextToImageImageUploaderContainer;
